import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { UserListFTPAccessModel } from 'src/Models/UserListFTPAccessModel';
import { Main911Service } from 'src/Services/main911.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ftp-data911',
  templateUrl: './ftp-data911.component.html',
  styleUrls: ['./ftp-data911.component.css']
})
export class FTPData911Component implements OnInit {
  tokenKey: any;
  isShowprogressSpinner: boolean = false;
  isloading: boolean = false;
  SubscriberUserList: UserListFTPAccessModel[];
  SubscriberUserListExport: UserListFTPAccessModel[];
  PageNumber: number = 1;
  PageSize: number = 30;
  orderBy: string = 'CompanyName';

  upDowCompanyNameCSS: string = '';
  upDowUserNameCSS: string = '';
  upDowNameCSS: string = '';
  upDowEmailCSS: string = '';

  openMenuIndex: number = -1;
  isAscending: boolean = false;
  isRecord: boolean = false;

  totalRecordCount: number = 0;

  public toolEnum = ToolEnum;

  constructor(private readonly toastr: ToastrService, private readonly main911Service: Main911Service, private readonly titleService: Title, private sessionStorageService: SessionStorageService) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('911 FTP Data');
  }

  ngOnInit() {
    this.GetSubscriberUserListForDownload();
  }

  uploadDataonFTP() {
    this.isShowprogressSpinner = true;
    this.main911Service.UploadDataonFTP(this.tokenKey, null).subscribe(
      result => {
        this.isShowprogressSpinner = false;
        this.showMessage('Data Upload and Email Send Successfully', 'Success', 'success');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  sendMail(userId) {
    this.isShowprogressSpinner = true;
    this.main911Service.UploadDataonFTP(this.tokenKey, userId).subscribe(
      result => {
        this.isShowprogressSpinner = false;
        this.showMessage('Data Upload and Email Send Successfully', 'Success', 'success');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  GetSubscriberUserListForDownload() {
    this.isloading = true;
    this.SubscriberUserList = [];
    this.main911Service.GetSubscriberUserList(this.tokenKey, this.PageNumber, this.PageSize, this.orderBy, ToolEnum.state911.toString(), false).subscribe(
      data => {
        this.isloading = false;
        this.SubscriberUserList = data['main'];

        if (this.SubscriberUserList != null) {
          if (this.SubscriberUserList.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.SubscriberUserList[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;

      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  sort(sortBy: any) {
    this.upDowCompanyNameCSS = '';
    this.upDowUserNameCSS = '';
    this.upDowNameCSS = '';
    this.upDowEmailCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UserName") {
        this.upDowUserNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Name") {
        this.upDowNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Email") {
        this.upDowEmailCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UserName") {
        this.upDowUserNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Name") {
        this.upDowNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Email") {
        this.upDowEmailCSS = 'fa fa-arrow-up';
      }

    }
    this.PageNumber = 1;
    this.GetSubscriberUserListForDownload();
  }

  Export911FTPData() {
    this.isloading = true;
    this.SubscriberUserListExport = [];
    this.main911Service.GetSubscriberUserList(this.tokenKey, this.PageNumber, this.PageSize, this.orderBy, ToolEnum.state911.toString(), true).subscribe(
      data => {
        this.SubscriberUserListExport = data['main'];
        if (this.SubscriberUserListExport.length > 0) {
          setTimeout(() => {
            this.Download911FTPData();
            this.isloading = false;
          }, 2000);
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  Download911FTPData() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'Export911FTPData';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "Export911FTPData.xls");
  }

}
